import { defineComponent as _defineComponent } from 'vue'
import './styles/loaders.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'Loaders',
  props: {
  type: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props;



const types = {
  label: 'table-cell',
  smallLabel: 'table-cell',
  truckIcon: 'button',
  tag: 'button',
  tagOnRight: 'button',
  deviceActivity: 'button',
  alertIcon: 'avatar',
  devicesListSearchbar: 'chip',
  sortControls: 'button',
  paginationControls: 'button',
  checkbox: 'button',
  expansionButton: 'button',
  expansionButtonWithoutMarginLeft: 'button',
  dataField: 'button'
};

return { __sfc: true,props, types }
}

})